/**
 * localstorage key 常量
 */
export const constants = {
  userinfo: 'liblibai_userinfo',
};
